import Api from "./Api";
import Utils from "../utilities/Utils";
import {
  BlobResponse,
  ExportIncomingSelfBillingOrderParams,
  IncomingSelfBillingOrder,
  IncomingSelfBillingOrderExportType,
} from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class IncomingSelfBillingOrdersController extends Api {
  static getIncomingSelfBillingOrders(page: number = 1, parameters = {}) {
    return fetch(
      `/api/incoming_self_billing_orders?page=${page}&${SearchHelper.getQueryString(
        parameters,
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      },
    ).then((res) => res.json());
  }

  static getForm(params: any) {
    return fetch(
      `/api/incoming_self_billing_orders/form?${Utils.encodeQueryData(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      },
    ).then((res) => res.json());
  }

  static update(ledgerItem: IncomingSelfBillingOrder) {
    return fetch(`/api/incoming_self_billing_orders/${ledgerItem.id}`, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ incoming_self_billing_order: ledgerItem }),
    }).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/incoming_self_billing_orders/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static exportIncomingSelfBillingOrders(
    params: ExportIncomingSelfBillingOrderParams,
  ): Promise<BlobResponse | { success: true }> {
    if ([IncomingSelfBillingOrderExportType.UBL].includes(params.type)) {
      return fetch(
        `/api/incoming_self_billing_orders/export?${Utils.encodeQueryData(
          params,
        )}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.token,
          },
          credentials: "same-origin",
        },
      ).then((res) => res.json());
    } else {
      return fetch(
        `/api/incoming_self_billing_orders/export?${Utils.encodeQueryData(
          params,
        )}`,
        {
          method: "POST",
          headers: {
            Authorization: this.token,
          },
          credentials: "same-origin",
        },
      ).then((res) => {
        return new Promise((resolve, reject) => {
          res.blob().then((blob) => {
            console.log(blob);
            resolve({
              filename: res.headers
                .get("content-disposition")
                .match(/filename="(.+)"/)[1],
              blob: blob,
            });
          });
        });
      });
    }
  }
}
